module.exports = __webpack_public_path__ + "static/media/study 201020.5e6dbcff.png";